var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.map)?_c('div',[(_vm.$vuetify.breakpoint.mdAndUp)?_c('l-control-attribution',{attrs:{"position":"bottomleft","prefix":`<a href='https://maps.gsi.go.jp/'> ${_vm.$t(
      'geographicalSurveyInstitute'
    )}</a> | <a href='https://leafletjs.com/'>Leaflet</a> | ${_vm.$t(
      'attribution'
    )}`}}):_c('l-control-attribution',{attrs:{"position":"topleft","prefix":`<a href='https://maps.gsi.go.jp/'>${_vm.$t(
      'geographicalSurveyInstitute'
    )}</a> | <a href='https://leafletjs.com/'>Leaflet</a>`}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }